












































import { Vue, Prop, Component } from "vue-property-decorator";
import { Agent as IAgent } from "@/api-v2/agent/models/agent";
import CustomTableItem from "@/components/form/CustomTableItem.vue";
import CustomTableCol from "@/components/form/CustomTableCol.vue";
import TableActions from "@/components/form/TableActions.vue";

@Component({
  components: { TableActions, CustomTableCol, CustomTableItem }
})
export default class AgentTableItem extends Vue {
  @Prop() agent!: IAgent;

  editHandler() {
    this.$router.push({ name: "agentEdit", params: { id: this.agent!.id! } });
  }

  removeHandler() {
    this.$emit("remove", this.agent);
  }
}
